import React, { useContext } from "react";
import Style1 from "./Style1";
import Style2 from "./Style2";
import Style3 from "./Style3";
import PsContext from "../../../../context";

const AdmissionHeroLeft = (props) => {
  const context = useContext(PsContext);
  const layoutValue = context.settingValue("admission_hero_left_section");

  // Prevent flash of Style 1 before context settings are loaded
  if (layoutValue === false && (!context.settings || context.settings.length === 0)) {
    return null;
  }

  const layout = Number(layoutValue) || 1;

  const renderLayout = () => {
    switch (layout) {
      case 1:
        return <Style1 />;
      case 2:
        return <Style2 />;
      case 3:
        return <Style3 />;
      default:
        return <Style1 />;
    }
  };

  return <div className="admission-hero-left-wrapper">{renderLayout()}</div>;
};

export default AdmissionHeroLeft;
